export default {
  test: 'Back to Calendar Items',
  untilDate: 'until {{dateString}}',
  untilOccurrences_one: 'until {{count}} occurrence',
  untilOccurrences_other: 'until {{count}} occurrences',
  recurrenceWithDayName: '{{calendarEventRecurrence}} on {{dayName}}',
};
